import React, { useState } from 'react';
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai';
import { words } from './data';
import { Link } from 'react-router-dom';

const SearchBar = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [activeSearch, setActiveSearch] = useState([]);
    const [showClearIcon, setShowClearIcon] = useState(false);
    const [isOpen, setIsOpen] = useState(true);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setShowClearIcon(value !== '');
        
        if (value === '') {
            setActiveSearch([]);
            return;
        }
        
        setActiveSearch(words.filter(word => word.includes(value)).slice(0, 8));

        setSearchTerm(e.target.value);
        setIsOpen(true); 
    };

    const handleClearSearch = () => {
        setSearchTerm('');
        setShowClearIcon(false);
        setActiveSearch([]);
    };

    return (
        <div className='flex justify-center pt-5'>
            <form className='w-[500px] relative justify-center items-center'>
                <div className='relative'>
                    <input 
                        type='search' 
                        placeholder='¿Qué estás buscando?' 
                        className='w-full p-4 rounded-full bg-white focus:outline-none focus:border-principal border-2' 
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                    {showClearIcon && (
                        <button 
                            onClick={handleClearSearch} 
                            className='absolute right-16 top-1/2 transform -translate-y-1/2 p-2 bg-white text-gray-400 rounded-full'>
                            <AiOutlineClose />
                        </button>
                    )}
                    <button className='absolute right-1 top-1/2 -translate-y-1/2 p-4 bg-principal text-white rounded-full'>
                        <AiOutlineSearch />
                    </button>
                </div>
                
                {

                isOpen && activeSearch.length > 0 && (
                    <div className='absolute top-20 p-4 bg-principal text-white w-full rounded-xl left-1/2 -translate-x-1/2 flex flex-col gap-2'>
                        {activeSearch.map((word, index) => (
                            <Link 
                                to={{
                                    pathname: `/${word.toLowerCase()}`,
                                    state: { title: word }
                                }}
                                key={index} 
                                className="hover:shadow-lg pl-4 pr-4 bg-principal text-white font-semibold rounded-full border-principal hover:bg-white hover:text-principal transition-all duration-300"
                                onClick={() => setIsOpen(false)}
                            >
                                {word}
                            </Link>
                        ))}
                    </div>
                )
                }
            </form>
        </div>
    )
};

export default SearchBar;
